export default __webpack_public_path__ + "assets/roboto-v18-latin-700.037d830.woff2";